export const columns = [
  {
    accessorKey: "icon",
    header: "Icon",
    type: "string",
    flex: 0.5,
    accessorFn: (row: any) => ` ${row.icon || " "}`,
  },
  {
    accessorKey: "name",
    header: "Name",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "isOutOfWareHouse",
    header: "Checked-out",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
